import React,{useEffect, useState} from 'react'
import API from '../../../../../../../API/API';
import $ from 'jquery'

const SubmitMappings = (props) => {
    const [isLoading, setIsLoading] = useState(false);
    const [allUpdatedMappings, setAllUpdatedMappings] = useState()
    
    useEffect(() => {
    },[])

    const submitSelectedMappings = () =>{
        var allMapping = []
        $("#newAttributeMappingTableNew tbody tr").each(function(){
            var mappingTable = {
                "ecommerceAttributeName": $(this).find("td:nth-child(6)").attr("headers"),
                "ecommerceAttributeDataType": $(this).find("td:nth-child(7)").attr("headers"),
                "ecommerceIsRequired":  $(this).find("td:nth-child(8)").attr("headers") === "true" ? true : false,
                "ecommerceAttributeSize": $(this).find("td:nth-child(9)").attr("headers"),
                "ecommerceAttributeType": $(this).find("td:nth-child(10)").attr("headers"),
                "erpAttributeName": $(this).find("td:nth-child(1)").attr("headers"),
                "erpAttributeDataType": $(this).find("td:nth-child(2)").attr("headers"),
                "erpIsRequired": $(this).find("td:nth-child(3)").attr("headers") === "true" ? true : false,
                "erpAttributeSize": $(this).find("td:nth-child(4)").attr("headers"),
                "erpAttributeType": $(this).find("td:nth-child(5)").attr("headers"),
                "canUpdate": true,
                "canDelete": true,
            }
            allMapping.push(mappingTable)
        })
        setIsLoading(true);
        var response =window.localStorage.getItem("accessToken") ;
        const headers={
            "authorization": `Bearer ${response}`,
            "content-type" : "application/json"
        };
        const body = {"sourceMappedSchemaList": allMapping}
        //Connection/{ConnectionId}/instance/{InstanceId}/save-customer-mappings/{RequestType}
        API.post(`/Connection/${props.connectorId}/instance/${props.instancesId}/save-customer-mappings/Source`, body, { headers })
        .then((response) => {
            if(response.status === 200){
                setIsLoading(false);
            }
        })
    }

    return (
        <>
            {isLoading ?
                <div className="spinner-container">
                    <div className="loading-spinner"></div>
                </div> : null
            }

            <button className='submitButton submitButton1' onClick={submitSelectedMappings}>
                Submit Mappings
            </button>
        </>
    )
}

export default SubmitMappings

